<template>
  <div class="mb-3">
    <v-layout wrap>
      <v-flex xs12>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="editItem = {groupDefList: []}"
        >
          Create User Group
        </v-btn>
        <v-icon color="primary">download</v-icon><a :href="userGroupsReport" target="_blank">Export User Group Report</a>
        <manager-user-groups-modal v-if="editItem" :user-group-details="editItem" :client-index="clientIndex" :client-details="clientDetails" @close="editItem = null" />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter User Groups"
          single-line
          hide-details
        />
        <v-data-table
          :headers="userGroupTableHeaders"
          :items="userGroupsList"
          :search="search"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr :class="props.item.recordInactiveFlag === 'A' ? '' : 'disabled-row'">
              <td :class="props.item.recordInactiveFlag === 'A' ? 'justify-center table-button-icons' : 'justify-center'">
                <v-btn
                  v-if="props.item.recordInactiveFlag === 'A'"
                  tooltip.hover
                  title="Edit user group"
                  icon
                  class="mx-0"
                  @click="editUsersByUserGroup(props.item)"
                >
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.recordInactiveFlag === 'A'"
                  tooltip.hover
                  title="Inactivate user group"
                  icon
                  class="mx-0"
                  @click="deactivateUserGroup(props.item)"
                >
                  <v-icon color="error">delete</v-icon>
                </v-btn>
                <v-icon
                  v-if="props.item.recordInactiveFlag !== 'A'"
                  tooltip.hover
                  title="User group is inactive"
                  class="mx-0"
                  color="orange"
                >
                  block
                </v-icon>
                <v-btn
                  v-if="props.item.recordInactiveFlag === 'A'"
                  tooltip.hover
                  title="Download user group report"
                  icon
                  class="mx-0"
                  :href="userGroupsReport + '/' + props.item.userGroupName"
                  target="_blank"
                >
                  <v-icon color="primary">download</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.userGroupName }}</td>
              <td>{{ props.item.userGroupDesc }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.createdOn | formatDate }}</td>
              <td>{{ props.item.lastModifiedBy }}</td>
              <td>{{ props.item.lastModifiedOn | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <manage-user-groups-deactivate-modal v-if="deactivateItem" :user-group="deactivateItem" @close="deactivateItem = null" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ManagerUserGroupsModal from './ManageUserGroupsModal'
import ManageUserGroupsDeactivateModal from './ManageUserGroupsDeactivateModal'
import urls from '@/store/modules/manageUserGroups.urls.js'
export default {
  name: 'manage-user-groups-table',
  components: {
    ManagerUserGroupsModal,
    ManageUserGroupsDeactivateModal
  },
  props: {
    userGroupsList: Array,
    clientIndex: Object,
    clientDetails: Array
  },
  data() {
    return {
      editItem: null,
      deactivateItem: null,
      search: '',
      userGroupsReport: urls.userGroupsReport,
      userGroupTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'User Group',
        value: 'userGroupName'
      },
      {
        text: 'User Group Description',
        value: 'userGroupDesc'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Last Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Last Modified On',
        value: 'lastModifiedOn'
      }
      ]
    }
  },
  computed: {
    ...mapState('manageUserGroups', ['userGroupDetails'])
  },
  methods: {
    ...mapMutations('manageUserGroups', ['setShowDeactivateUserGroupModal']),
    ...mapActions('manageUserGroups', ['getUserGroupDetails']),
    editUsersByUserGroup(item) {
      this.getUserGroupDetails(item.userGroupId).then(() => this.editItem = this.userGroupDetails)
    },
    deactivateUserGroup(item) {
      this.deactivateItem = item
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-button-icons {
    white-space: nowrap;
    padding-left: 5px !important;
  }
  .disabled-row {
    &:hover{
      background-color: $black-10 !important;
    }
    background-color: $black-10;
  }
</style>
